import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { doLogin } from '../../services/AuthService';
import './Login.css';

function Login() {

    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');

    function onChangeInput(event) {
        if (event.target.id === 'email')
            setEmail(event.target.value);
        else
            setPassword(event.target.value);
    }

    function onSubmit(event) {
        event.preventDefault();

        doLogin(email, password)
            .then(response => {
                localStorage.setItem('token', response.token);
            localStorage.setItem('hasFutures', response.hasFutures);
            localStorage.setItem('hasLaunch', response.hasLaunch);
            if (typeof response.hasAgent !== 'undefined') localStorage.setItem('hasAgent', response.hasAgent);
            if (typeof response.hasAIAgent !== 'undefined') localStorage.setItem('hasAIAgent', response.hasAIAgent);
            if (typeof response.hasQuickStrategy !== 'undefined') localStorage.setItem('hasQuickStrategy', response.hasQuickStrategy);
            if (typeof response.hasSwap !== 'undefined') localStorage.setItem('hasSwap', response.hasSwap);
            if (typeof response.hasEasyTrade !== 'undefined') localStorage.setItem('hasEasyTrade', response.hasEasyTrade);
            if (typeof response.hasGridAI !== 'undefined') localStorage.setItem('hasGridAI', response.hasGridAI);
            if (typeof response.limitName !== 'undefined') localStorage.setItem('limitName', response.limitName);
            if (typeof response.isCustody !== 'undefined') localStorage.setItem('isCustody', response.isCustody);
                localStorage.setItem('id', response.id);
                navigate('/dashboard');
            })
            .catch(err => {
                console.error(err);
                setError(`Usuário e/ou senha inválidos!`);
            })
    }

    return (
        <main className="login-page">
            <div className="login-wrapper">
                <div className="login-card">
                    <div className="login-logo">
                        <img src="/img/favicon/mstile-150x150.png" alt="EasyCripto" />
                        <h1 className="login-title">EasyCripto</h1>
                        <p className="login-subtitle">Entre para controlar e automatizar suas estratégias</p>
                    </div>
                    <form className="login-form" onSubmit={onSubmit}>
                        <div className="form-group mb-3">
                            <label htmlFor="email" className="text-gray-400 small mb-1">E-mail</label>
                            <div className="login-input-group">
                                <input
                                    type="email"
                                    className="form-control"
                                    placeholder="seu@email.com"
                                    id="email"
                                    autoFocus
                                    required
                                    onChange={onChangeInput}
                                />
                            </div>
                        </div>
                        <div className="form-group mb-3">
                            <label htmlFor="password" className="text-gray-400 small mb-1">Senha</label>
                            <div className="login-input-group">
                                <input
                                    type="password"
                                    placeholder="Sua senha"
                                    className="form-control"
                                    id="password"
                                    required
                                    onChange={onChangeInput}
                                />
                            </div>
                        </div>
                        <div className="login-remember-forgot mb-3">
                            <div className="form-check">
                                <input className="form-check-input" type="checkbox" value="" id="remember" />
                                <label className="form-check-label mb-0" htmlFor="remember">
                                    Lembrar de mim
                                </label>
                            </div>
                            <div>
                                <Link to="/forgot-password" className="small">Esqueceu a senha?</Link>
                            </div>
                        </div>
                        <div className="d-grid mb-2">
                            <button type="submit" className="btn login-button">Entrar</button>
                        </div>
                        <div className="d-grid mb-2">
                            <a
                                className="btn login-card-button"
                                href="https://go.kast.xyz/VqVO/WR433SE1?af_js_web=true&af_ss_ver=2_9_5&pid=referral&c=WR433SE1"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Quero um cartão
                            </a>
                        </div>
                        {error && (
                            <div className="alert alert-danger mt-2 login-error">{error}</div>
                        )}
                    </form>
                </div>
                <div className="login-bottom-card">
                    <span>
                        Tem um código de convite?
                        <Link to="/register" className="ms-1">Criar conta</Link>
                    </span>
                </div>
                <div className="login-footer-links">
                    <Link to="/">Voltar para a página inicial</Link>
                </div>
            </div>
        </main>
    );
}

export default Login;
